/**
 * wagbappro.id PC 页印尼语内容（文案 1:1 还原需求文档）
 */
const img = (name) => require(`@/assets/wagbappro/${name}`);

/** 真实内容图（content/ 目录） */
export const images = {
  hero: img('content/14-pc-hero.webp'),
};

export const intro = {
  paragraphs: [
    {
      textBefore: 'GB WhatsApp untuk PC adalah solusi bagi pengguna yang ingin menjalankan ',
      linkText: 'WA GB',
      linkTo: '/',
      textAfter:
        ' di komputer dengan layar yang lebih besar, navigasi lebih nyaman, dan pengalaman chatting yang lebih fleksibel. Meskipun tidak tersedia versi resmi untuk PC, kamu tetap bisa menggunakannya melalui beberapa metode sederhana tanpa mengubah fungsi utama aplikasi.',
    },
    'Dengan menggunakan GB WhatsApp di PC, pengguna dapat lebih mudah mengetik pesan, mengelola chat, serta melakukan multitasking saat bekerja atau belajar.',
  ],
  cta: 'Unduh GB WhatsApp untuk PC Sekarang',
  ctaLink: '/unduh-gb-wa/',
};

export const sections = {
  whatIs: {
    id: 'apa-itu-gb-whatsapp-pc',
    title: 'Apa itu GB WhatsApp untuk PC?',
    paragraphs: [
      'GB WhatsApp untuk PC bukan aplikasi resmi Windows, tetapi merupakan cara untuk menjalankan GB WhatsApp di komputer menggunakan metode tertentu. Aplikasi ini tetap menggunakan akun WhatsApp yang sama seperti di ponsel, sehingga semua chat tetap sinkron selama login aktif.',
      'Pengguna biasanya memilih versi PC karena lebih nyaman digunakan untuk aktivitas harian seperti komunikasi kerja, bisnis, atau penggunaan pribadi dengan layar yang lebih besar.',
    ],
  },
  methods: {
    id: 'cara-menggunakan-gb-whatsapp-pc',
    title: 'Cara Menggunakan GB WhatsApp di PC',
    intro: 'Ada beberapa metode yang bisa digunakan untuk menjalankan WA GB di komputer:',
    items: [
      {
        id: 'emulator-android',
        title: 'Emulator Android (Metode Paling Lengkap)',
        desc: 'Emulator seperti BlueStacks, LDPlayer, atau NoxPlayer memungkinkan kamu menjalankan WA GB APK langsung di PC seperti di smartphone.',
        descHtml: true,
        stepsLabel: 'Langkah umum:',
        steps: [
          'Install emulator di PC',
          'Login Google account',
          'Download file WA GB APK',
          'Instal di dalam emulator',
          'Buka dan gunakan seperti biasa',
        ],
      },
      {
        id: 'perangkat-tertaut',
        title: 'Perangkat Tertaut (Linked Devices)',
        desc: 'Metode ini menggunakan fitur WhatsApp yang menghubungkan akun HP ke PC.',
        stepsLabel: 'Langkah:',
        steps: [
          'Buka WA GB di HP',
          'Masuk ke menu perangkat tertaut',
          'Scan QR code dari browser PC',
          'Mulai gunakan di komputer',
        ],
      },
      {
        id: 'screen-mirroring',
        title: 'Screen Mirroring',
        desc: 'Jika kamu tidak ingin install emulator, kamu bisa menampilkan layar HP ke PC.',
        stepsLabel: 'Aplikasi yang bisa digunakan:',
        steps: ['AirDroid', 'ApowerMirror', 'AnyDesk (mode kontrol layar)'],
      },
    ],
  },
  advantages: {
    id: 'kelebihan-wa-gb-pc',
    title: 'Kelebihan Menggunakan WA GB di PC',
    intro: 'Menggunakan GB WhatsApp di komputer memberikan beberapa keuntungan:',
    items: [
      'Layar lebih besar dan nyaman untuk membaca chat',
      'Lebih cepat mengetik menggunakan keyboard',
      'Cocok untuk multitasking kerja atau bisnis',
      'Manajemen chat lebih rapi',
      'Tetap menggunakan satu akun yang sama',
    ],
  },
  info: {
    id: 'informasi-singkat',
    title: 'Informasi Singkat',
    rows: [
      { label: 'Nama', value: 'GB WhatsApp untuk PC' },
      { label: 'Versi', value: 'Terbaru 2026' },
      { label: 'Platform', value: 'Windows / PC / Laptop' },
      { label: 'Metode', value: 'Emulator / Web / Screen Mirroring' },
      { label: 'Kebutuhan', value: 'Android + koneksi internet stabil' },
      { label: 'Status', value: 'Aplikasi modifikasi (tidak resmi)' },
    ],
  },
  notice: {
    id: 'catatan-penting',
    title: 'Catatan Penting',
    paragraphs: [
      'GB WhatsApp untuk PC tidak tersedia secara resmi di Microsoft Store atau Windows. Semua metode yang digunakan bersifat alternatif dan membutuhkan aplikasi tambahan seperti emulator atau fitur perangkat tertaut.',
      'Sebaiknya selalu gunakan versi terbaru WA GB APK agar lebih stabil dan mengurangi risiko error saat digunakan di PC.',
    ],
  },
  problems: {
    id: 'masalah-yang-mungkin-terjadi',
    title: 'Masalah yang Mungkin Terjadi',
    intro: 'Beberapa pengguna mungkin mengalami kendala berikut:',
    items: [
      'Emulator tidak bisa berjalan di PC spesifikasi rendah',
      'QR code tidak bisa dipindai',
      'Aplikasi lemot saat multitasking',
      'Chat tidak sinkron dengan HP',
    ],
    tip: 'Biasanya masalah ini bisa diatasi dengan update versi emulator atau menggunakan metode alternatif lain.',
  },
  conclusion: {
    id: 'kesimpulan',
    title: 'Kesimpulan',
    text: 'GB WhatsApp untuk PC memberikan solusi praktis bagi pengguna yang ingin pengalaman chatting lebih nyaman di layar besar. Dengan beberapa metode seperti emulator, perangkat tertaut, atau screen mirroring, kamu bisa tetap menggunakan WA GB tanpa batasan perangkat.',
  },
};
